import moment from "moment";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_TIME_GET_ALL_REQUESTS_BADGE_COUNTER } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";
import { useMyTimeActualDate } from "my-time/hooks";

export const useMyTimeRequestCount = () => {
  const { date } = useMyTimeActualDate();
  const startDate = moment(date).startOf("month").toDate();
  const endDate = moment(date).endOf("month").toDate();
  const { data, loading, error, refetch } = useQuery(
    MY_TIME_GET_ALL_REQUESTS_BADGE_COUNTER,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        startDate,
        endDate,
      },
    },
  );

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.allRequestsBadgeCounter || 0,
    loading,
    error,
  };
};

export default useMyTimeRequestCount;
